module.exports = __webpack_public_path__ + "assets/123d6c1e88f781f8cc084108aceae609.png";